import React from 'react';
import { VOLUMES } from '../data/catio';
interface VolumeFanProps {
  priority?: boolean;
  tone?: 'light' | 'dark';
  className?: string;
}

/**
 * The five real volume covers composed as a layered fan (never a flat row).
 * Offsets are % of a cover's own width, so the fan scales with its container
 * and always stays inside it — from 360px phones to desktop.
 */
const FAN = [{
  x: -88,
  rotate: -6,
  scale: 0.88,
  z: 1
}, {
  x: -44,
  rotate: -3,
  scale: 0.94,
  z: 2
}, {
  x: 0,
  rotate: 0,
  scale: 1,
  z: 3
}, {
  x: 44,
  rotate: 3,
  scale: 0.94,
  z: 2
}, {
  x: 88,
  rotate: 6,
  scale: 0.88,
  z: 1
}];
export function VolumeFan({
  priority = false,
  tone = 'light',
  className = ''
}: VolumeFanProps) {
  return <div className={`relative w-full ${className}`} style={{
    aspectRatio: '2.05 / 1'
  }} role="img" aria-label="The five CATIO READY™ volumes: Window & Compact, Balcony & Small-Space, Patio & Attached, Freestanding Backyard, and Walk-In & Large Catios." data-id="element-344" data-mp="rrj4moggnuai">
      <div className={`absolute bottom-0 left-[10%] right-[10%] h-[7%] rounded-[50%] blur-xl ${tone === 'dark' ? 'bg-black/70' : 'bg-ink/30'}`} aria-hidden data-id="element-345" data-mp="28lx5ko4ms0lm" />
      {VOLUMES.map((volume, index) => {
      const f = FAN[index];
      return <img key={volume.id} src={volume.cover} alt="" width={1530} height={1980} loading={priority ? 'eager' : 'lazy'} decoding="async" className="absolute bottom-[3%] left-1/2 w-[34%] rounded-[2px] object-cover shadow-[0_18px_28px_-12px_rgba(0,0,0,0.6)] ring-1 ring-black/10" style={{
        aspectRatio: '1530 / 1980',
        zIndex: f.z,
        transform: `translateX(-50%) translateX(${f.x}%) rotate(${f.rotate}deg) scale(${f.scale})`,
        transformOrigin: '50% 100%'
      }} data-id="element-346" data-mp="2dlsz1tfpc9mx" data-mpi={index} />;
    })}
    </div>;
}